const appointmentAnalytics = 'appointment-analytics';

export const trackingIds = {
  chartsView: `${appointmentAnalytics}-charts-view-tab`,
  clearFilters: `${appointmentAnalytics}-clear-filters`,
  downloadMain: `${appointmentAnalytics}-download-main`,
  filtersOpen: `${appointmentAnalytics}-filters-open`,
  helpVideo: `${appointmentAnalytics}-help-video`,
  tableView: `${appointmentAnalytics}-table-view-tab`,
} as const;
